// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider[data-v-47a2ae42]{display:flex;flex-direction:row;background:#f5f5f6;padding:4px 12px;margin:8px 2px 2px 2px;border:3px solid #eee;border-radius:10px 10px 0 0;text-align:center}.label[data-v-47a2ae42]{font-size:14px;font-weight:500;color:#999;margin:2px auto 0 auto}@media(max-width: 900px){.label[data-v-47a2ae42]{font-size:11px !important}}", ""]);
// Exports
module.exports = exports;
